import { CheckBox, DataGrid, DateBox, NumberBox, SelectBox } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import urlReport from '../../services/reportServices';
import Box, { Item } from 'devextreme-react/box';
import { formatDate } from '../../data/app';
import moment from 'moment';
import http from '../../utils/http';
import { dataSource } from '../../components/dropdown/ClienteDropDown';
import { years, months } from '../../reports/bills/data';
import { dateRange } from '../../data/defaultObjects';
import { Column, Export, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';

const Reports = ({ reportName }) => {
    return (
        <div>
            <WhichReport reportName={reportName} />
        </div>
    );
}

export default Reports;

const WhichReport = ({ reportName }) => {

    const report = urlReport();

    switch (reportName) {
        case 'ClientList':
            return <RedirecToReport title='Reporte de clientes' url={report.clients} />;
        case 'ClientMora':
            return <RedirecToReport title='Reporte de clientes deudores' url={report.clientsMora} />;
        case 'ClientPorEdad':
            return <ReportContainer title='Reporte clientes por edad'><ClientPorEdad /></ReportContainer>;
        case 'RecordList':
            return <ReportContainer title='Reporte de graduaciones'><RecordList /></ReportContainer>;
        case 'BillSeason':
            return <ReportContainer title='Reporte de ventas'><BillList /></ReportContainer>;
        case 'ItemsList':
            return <ReportContainer title='Venta por articulo'><ItemsList /></ReportContainer>;
        case 'Inventario':
            return <ReportContainer title='Inventario'><Inventario /></ReportContainer>;
        case 'Proveedores':
            return <RedirecToReport title='Reporte de proveedores' url={report.proveedores} />;
        case 'Valoracion':
            return <RedirecToReport title='Valoracion de Almacen' url={report.valoracion} />;
        case 'CuentasPorPagar':
            return <RedirecToReport title='Cuentas Por Pagar' url={report.compras} />;
        case 'VentaMes':
            return <ReportContainer title='Ventas de Lente del mes' ><SalesReport /></ReportContainer>;
        case 'Stock':
            return <ReportContainerMain sizeLayout='medium' title='Productos con stock bajo' ><StockReport /></ReportContainerMain>;
        default:
            return <>No hay reportes</>;
    }

}

const StockReport = () => {

    const [products, setProducts] = useState([]);

    const getProducts = async() => {
    
        const data = await http('reports/products-stock').asGet();
        setProducts(data);
    

    }
    useEffect(() => {
        getProducts();
    }, []);

    return (
        <div className="container">
            <DataGrid
                dataSource={products}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                rowAlternationEnabled={true}               
            >
                <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={15} />
                <FilterRow visible={true} />
                <Export enabled={true} fileName={'Productos'} allowExportSelectedData={true} />
                <Column dataField="code" caption='Codigo' width={120} />
                <Column dataField="name" caption='Producto' />
                <Column dataField="stock" caption={'Existencia'}  width={120}/>
                <Column dataField="minStock" caption={'Stock Minimo'}  width={120}/>
            </DataGrid>
        </div>
    )

}

const Inventario = () => {

    const tipos = [
        { id: 0, name: 'Todos' },
        { id: 1, name: 'A-Lentes oftalmicos' },
        { id: 2, name: 'C-Lentes de contacto' },
        { id: 3, name: 'B-Marco/Aro' },
        { id: 5, name: 'D-Accesorios' },
        { id: 6, name: 'F-Lentes Esclerales' },
    ];

    const [tipo, setTipo] = useState(null);

    const generateReport = () => {

        const _tipo = tipo == 0 ? '' : tipo;

        const report = urlReport();
        report.print(report.inventario(_tipo));

    }


    return (
        <div>
            <Box>
                <Item ratio={1} />
                <Item ratio={2}>
                    <div className="p-10">
                        <label htmlFor="">Tipo</label>
                        <SelectBox items={tipos}
                            defaultValue={0}
                            showClearButton={true}
                            displayExpr="name"
                            valueExpr="id"
                            onValueChanged={e => setTipo(e.value)} />
                    </div>
                </Item>
                <Item ratio={1} />
            </Box>

            <BtnPrint text='Cargar el reporte' generateReport={generateReport} />
        </div>
    )

}

const SalesReport = () => { 
    
    const [data, setData] = useState({year : null, month: null});

    const generateReport = () => {        

        const date = moment(data.year + '-' + data.month, 'YYYY-MM').format('YYYY-MM-DD');

        const report = urlReport();
        report.print(report.sales(date));

    }

    const isDataSelected = data.year && data.month;


    return (
        <div>
            <Box>
                <Item ratio={1} />
                <Item ratio={1}>
                    <div className="p-10">
                        <label htmlFor="">Año</label>
                        <SelectBox items={years}
                            defaultValue={0}
                            onValueChanged={e => setData({ ...data, year: e.value })} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="p-10">
                        <label htmlFor="">Mes</label>
                        <SelectBox items={months}
                            defaultValue={0}
                            displayExpr="name"
                            valueExpr='id'
                            onValueChanged={e => setData({ ...data, month: e.value })} />
                    </div>
                </Item>
                <Item ratio={1} />
            </Box>

            <BtnPrint disabled={!isDataSelected} text='Cargar el reporte' generateReport={generateReport} />
        </div>
    )

}


const ItemsList = () => {

    const [data, setData] = useState({from : dateRange.from, to: dateRange.to});

    const generateReport = () => {

        const from =  moment(data.from).format('YYYY-MM-DD');
        const to   =  moment(data.to).format('YYYY-MM-DD');             

        const report = urlReport();
        report.print(report.items(from, to));

    }
   

    return (
        <div> 
            <Box>
                <Item ratio={1}/>
                <Item ratio={1}>
                    <div className="p-10">
                        <label htmlFor="">Desde</label>
                        <DateBox type="date" name="from" 
                            defaultValue={data.from}
                            displayFormat={formatDate} openOnFieldClick={true} 
                            onValueChanged={e => setData({...data, from: e.value})}/>
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="p-10">
                        <label htmlFor="">Hasta</label>
                        <DateBox type="date" name="from" displayFormat={formatDate} 
                            defaultValue={data.to}
                            openOnFieldClick={true} 
                            onValueChanged={e => setData({...data, to: e.value})}/>
                    </div>
                </Item>
                <Item ratio={1}/>
            </Box>

            <BtnPrint text='Cargar el reporte' generateReport={generateReport} />
        </div>
    )

}

const BillList = () => {

    const [data, setData] = useState({ from : dateRange.from, to: dateRange.to, username: '' });
    const [users, setUsers] = useState([]);

    const generateReport = () => {

        const from = moment(data.from).format('YYYY-MM-DD');
        const to = moment(data.to).format('YYYY-MM-DD');

        let queryString = `from=${from}&to=${to}&username=${data.username || ''}`;

        const report = urlReport();
        report.print(report.bills(queryString));

    }

    useEffect(() => {

        http('users/getall').asGet().then(res => {
            setUsers(res);
        });

    }, [0]);

    return (
        <div>
            <Box>
                <Item ratio={1} />
                <Item ratio={1}>
                    <div className="p-10">
                        <label htmlFor="">Desde</label>
                        <DateBox type="date" name="from"
                            defaultValue={data.from}
                            displayFormat={formatDate} openOnFieldClick={true}
                            onValueChanged={e => setData({ ...data, from: e.value })} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="p-10">
                        <label htmlFor="">Hasta</label>
                        <DateBox type="date" name="from" 
                            defaultValue={data.to}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={e => setData({ ...data, to: e.value })} />
                    </div>
                </Item>
                <Item ratio={1} />
            </Box>
            <Box>
                <Item ratio={1} />
                <Item ratio={2}>
                    <div className="p-10">
                        <label htmlFor="">Vendedor</label>
                        <SelectBox items={users}
                            showClearButton={true}
                            displayExpr="fullName"
                            valueExpr="username"
                            onValueChanged={e => setData({ ...data, username: e.value })} />
                    </div>
                </Item>
                <Item ratio={1} />
            </Box>

            <BtnPrint text='Cargar el reporte' generateReport={generateReport} />
        </div>
    )

}

const RecordList = () => {

    const [data, setData] = useState({ from : dateRange.from, to: dateRange.to, clientId: 0 });

    const generateReport = () => {

        if (data.from && data.to) {

            const from = moment(data.from).format('YYYY-MM-DD');
            const to = moment(data.to).format('YYYY-MM-DD');

            const report = urlReport();
            report.print(report.records(from, to, data.clientId));

        }
    }

    return (
        <div>

            <Box>
                <Item ratio={1} />
                <Item ratio={2}>
                    <div className="p-10">
                        <label htmlFor="">Desde</label>
                        <DateBox type="date" name="from"
                            defaultValue={data.from}
                            displayFormat={formatDate} openOnFieldClick={true}
                            onValueChanged={e => setData({ ...data, from: e.value })} />
                    </div>
                </Item>
                <Item ratio={2}>
                    <div className="p-10">
                        <label htmlFor="">Hasta</label>
                        <DateBox type="date" name="from" 
                            defaultValue={data.to}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={e => setData({ ...data, to: e.value })} />
                    </div>
                </Item>
                <Item ratio={1} />
            </Box>
            <Box>
                <Item ratio={1} />
                <Item ratio={4}>
                    <div className="p-10">
                        <label htmlFor="">Cliente</label>
                        <SelectBox dataSource={dataSource()}
                            defaultValue={0}
                            showClearButton={true}
                            displayExpr={item => item ? `${item.id} - ${item.name} ${item.lastName}` : ''}
                            valueExpr="id"
                            onValueChanged={e => setData({ ...data, clientId: e.value })} />
                    </div>
                </Item>
                <Item ratio={1} />
            </Box>
            <BtnPrint text='Cargar el reporte' generateReport={generateReport} />
        </div>
    )

}


const ClientPorEdad = () => {

    const [porEdad, setPorEdad] = useState(true);
    const [data, setData] = useState({ from: 0, to: 0, date: null });

    const generateReport = () => {

        let queryString = '';//``from=${from}&to=${to}&nace=${date}

        if (porEdad) {
            queryString = `from=${data.from}&to=${data.to}`;
        }
        else {
            const date = moment(data.date).format('YYYY-MM-DD');
            queryString = `nace=${date}`;
        }

        const report = urlReport();
        report.print(report.clientsPorEdad(queryString));

    }

    return (
        <div>
            {porEdad &&
                <Box>
                    <Item ratio={1} />
                    <Item ratio={1}>
                        <div className="p-10">
                            <label htmlFor="">Desde</label>
                            <NumberBox
                                defaultValue={data.from}
                                showSpinButtons={true}
                                onValueChanged={(e) => setData({ ...data, from: e.value })}
                            />
                        </div>
                    </Item>
                    <Item ratio={1}>
                        <div className="p-10">
                            <label htmlFor="">Hasta</label>
                            <NumberBox
                                defaultValue={data.to}
                                showSpinButtons={true}
                                onValueChanged={(e) => setData({ ...data, to: e.value })}
                            />
                        </div>
                    </Item>
                    <Item ratio={1} />
                </Box>
            }
            {!porEdad &&
                <Box>
                    <Item ratio={1} />
                    <Item ratio={1}>
                        <div className="p-10">
                            <label htmlFor="">Fecha Nacimiento</label>
                            <DateBox type="date" name="from" displayFormat={formatDate} openOnFieldClick={true}
                                onValueChanged={e => setData({ ...data, date: e.value })} />
                        </div>
                    </Item>
                    <Item ratio={1} />
                </Box>
            }

            <BtnPrint text='Cargar el reporte' generateReport={generateReport} />

            <div className='options'>
                <Box direction="row" width="100%">
                    <Item ratio={1}>
                        {!porEdad && <CheckBox text='Por edad' defaultValue={true} value={porEdad} onValueChanged={e => setPorEdad(true)} />}
                    </Item>
                </Box>
                <Box direction="row">
                    <Item ratio={1}>
                        {porEdad && <CheckBox text='Por fecha' defaultValue={false} value={!porEdad} onValueChanged={e => setPorEdad(false)} />}
                    </Item>
                </Box>
            </div>
        </div>
    )

}

const RedirecToReport = ({ url, title }) => {

    const imprimir = () => {

        const printer = urlReport();
        printer.print(url);

    }

    return (
        <ReportContainer title={title}>
            <BtnPrint text='Cargar el reporte' generateReport={imprimir} />
        </ReportContainer>
    );
}

const BtnPrint = ({ disabled= false, text = 'Cargar el reporte', generateReport = () => 0 }) => {

    return (
        <button className='btn btn-primary' onClick={generateReport} disabled={disabled}>
            {text}
        </button>
    );

}

const ReportContainer = ({ title, children }) => {

    return <ReportContainerMain title={title}>
        {children}
    </ReportContainerMain>
    
}

const ReportContainerMain = ({ title, children, sizeLayout = 'small' }) => {

    return (
        <div className={`container text-center mt-50 ${sizeLayout}`}>
            <h4>{title}</h4>
            {children}
        </div>
    );

}